// extracted by mini-css-extract-plugin
export default {"button":"_o-z","reviewSort":"ap-z"};